export default "__VITE_ASSET__8aa34a6a__"